import { createMuiTheme } from '@material-ui/core'

export const bmsTheme = theme =>
	createMuiTheme({
		palette: {
			primary: {
				main: theme.primary(theme).backgroundColor,
				light: theme.primary(theme).backgroundColor,
				dark: theme.primary(theme).backgroundColor,
			},
			secondary: {
				main: theme.primary(theme).backgroundColor,
			},
		},
		typography: {
			htmlFontSize: theme.spaces[16],
		},
	})

export const __wrapper = () => ({
	marginTop: '28px',
})

export const __description = ({ theme }) => ({
	color: theme.primary(theme).formTextColor,
	fontSize: theme.fontSize.s,
	marginTop: '4px',
})
